// convert a number [meter] to "default" display text [meter]
// Example: 4 (for 4.0) and 24.5 (for 24.51)
export const display_default_meassure_from_meter = (meter: number): string => {
  // todo(Gustav): use user units
  const withDecimalPoint = meter.toFixed(3); // string value is 4.000 or 24.123
  const clippedNumber = Number.parseFloat(withDecimalPoint); // number value is 4.000 or 24.5123
  const removedPointZero = clippedNumber.toString(); // now a string that removes .0 from the 4 but not .123 from 24.123
  return removedPointZero;
};

// convert a number [meter] to "detailed" display text [milli-meter]
export const display_detail_meassure_from_meter = (m: number) => {
  return (m * 1000).toFixed(0);
};
